/**
 * Breakpoint values
 * @enum {string}
 */
export enum Breakpoint {
  Medium = 'medium',
  Large = 'large',
}